import React from 'react'
import {Flex, Stack, Text, useMultiStyleConfig, Button} from '@chakra-ui/react'
import {remCalc} from '../../theme/_utils'
import {LocatorIcon, TelephoneIcon, WebsiteIcon} from '../../components/icons'
import {useIntl} from 'react-intl'
import PropTypes from 'prop-types'
import {generateGoogleMapsLinkFromAddress} from '../../utils/googleMapsUtils'
import {checkboxMessages} from '../../pages/authorized-service-center'
import {useGoogleTagManager} from '../../custom-api/hooks/use-google-tag-manager'
import {basic_gtm_event} from '../../custom-api/layers/default'

const ServiceCenterTooltip = (props) => {
    const {formatMessage} = useIntl()
    const intl = useIntl()
    const styles = useMultiStyleConfig('ServiceCenterLocator')

    const {addLayer} = useGoogleTagManager()
    const fireServiceLocatorEvent = (label) => {
        addLayer(
            basic_gtm_event.bind(this, {
                event: 'serviceLocator',
                eventCategory: 'afterSales',
                eventAction: 'serviceLocator',
                eventLabel: label,
            }),
        )
    }

    return (
        <>
            {props.selectedStore && (
                <Flex {...styles.serviceCenterAddressMainContainer} key={props.selectedStore.id}>
                    <Stack gap={{base: remCalc(10)}}>
                        <Stack gap={remCalc(1)}>
                            <Flex lineHeight={remCalc(16)}>
                                <Text {...styles.addressDescription}>
                                    {props.selectedStore.address1}
                                </Text>
                            </Flex>
                            <Flex flexDir="row">
                                {props.selectedStore.city && (
                                    <Text {...styles.addressDescription}>
                                        {props.selectedStore.city + ', '}
                                    </Text>
                                )}
                                {props.selectedStore.postalCode && (
                                    <Text {...styles.addressDescription}>
                                        {props.selectedStore.postalCode + ', '}
                                    </Text>
                                )}
                                {props.selectedStore.stateCode && (
                                    <Text {...styles.addressDescription}>
                                        {props.selectedStore.stateCode + ', '}
                                    </Text>
                                )}
                                {props.selectedStore.countryCode && (
                                    <Text {...styles.addressDescription}>
                                        {props.selectedStore.countryCode}
                                    </Text>
                                )}
                            </Flex>
                            <Flex style={{flexDirection: 'column'}} lineHeight={remCalc(16)}>
                                {props.selectedStore?.c_services?.map((service, index) => (
                                    <Text
                                        key={index}
                                        color="text.secondary"
                                        {...styles.addressDescription}
                                    >
                                        {intl.formatMessage(checkboxMessages[service])}
                                        {index < props.selectedStore.c_services.length - 1
                                            ? ', '
                                            : ''}
                                    </Text>
                                ))}
                            </Flex>
                        </Stack>
                        <Flex {...styles.serviceCenterContact}>
                            <TelephoneIcon {...styles.addressIcons} />
                            <Text
                                {...styles.addressDescription}
                                as="a"
                                href={`tel:${props.selectedStore.phone}`}
                            >
                                {props.selectedStore.phone}
                            </Text>
                        </Flex>
                        {props.selectedStore?.c_websiteUrl && (
                            <Flex {...styles.serviceCenterContact}>
                                <WebsiteIcon {...styles.addressIcons} />
                                <Text
                                    {...styles.addressDescription}
                                    as="a"
                                    href={props.selectedStore?.c_websiteUrl}
                                    target="_blank"
                                >
                                    {props.selectedStore?.c_websiteUrl}
                                </Text>
                            </Flex>
                        )}
                        <Flex display={{base: 'flex', lg: 'none'}} {...styles.serviceCenterContact}>
                            <WebsiteIcon {...styles.addressIcons} />
                            <Text {...styles.addressDescription}>{props.selectedStore?.email}</Text>
                        </Flex>
                        <Flex {...styles.serviceCenterContact}>
                            <LocatorIcon w={remCalc(11)} {...styles.addressIcons} />
                            <Text {...styles.addressDescription}>
                                {props.selectedStore.distance +
                                    ' ' +
                                    props.selectedStore.distanceUnit}
                            </Text>
                        </Flex>
                    </Stack>
                    <Flex {...styles.serviceCenterInfoPopupButtons}>
                        <Button
                            {...styles.mapTooltipContactButton}
                            as="a"
                            href={
                                props.selectedStore?.email
                                    ? `mailto:${props.selectedStore.email}`
                                    : undefined
                            }
                            onClick={() => {
                                if (props.selectedStore?.email) {
                                    fireServiceLocatorEvent('visitWebsite')
                                }
                            }}
                        >
                            {formatMessage({
                                defaultMessage: 'Contact us',
                                id: 'service-center-locator.info-popup-contact-button',
                            })}
                        </Button>
                        <Button
                            {...styles.tooltipGoToMapsButton}
                            variant="link"
                            as="a"
                            href={generateGoogleMapsLinkFromAddress(
                                props.selectedStore.name,
                                props.selectedStore.address1,
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => fireServiceLocatorEvent('googleMaps')}
                        >
                            {formatMessage({
                                defaultMessage: 'Google maps',
                                id: 'service-center-locator.info-popup-google-maps-button',
                            })}
                        </Button>
                    </Flex>
                </Flex>
            )}
        </>
    )
}

ServiceCenterTooltip.propTypes = {
    selectedStore: PropTypes.object,
}
export default ServiceCenterTooltip
